
console.log("Parcel is working. Hurray!");


//# sourceMappingURL=index.9799743f.js.map
